import LoginStore from './LoginStore';

export * from './LoginStore.dto';

const loginStore = new LoginStore();
export default loginStore;
